/**
 * Enlace al repo de un proyecto: un ícono que abre el repo en otra pestaña. No dibuja nada si el
 * proyecto no tiene enlace.
 *
 * Aunque la API ya solo guarda URLs http/https, se vuelve a comprobar aquí antes de armar el `<a href>`
 * (un `javascript:` nunca debe llegar a un `href`).
 */
import { enlaceRepoSchema } from '@cdtec-backlog/contrato';
import './EnlaceRepo.css';

interface Props {
  proyecto: { nombre: string; enlaceRepo: string | null };
}

export function esEnlaceRepoValido(enlace: string | null | undefined): enlace is string {
  return !!enlace && enlaceRepoSchema.safeParse(enlace).success;
}

export function EnlaceRepo({ proyecto }: Props) {
  if (!esEnlaceRepoValido(proyecto.enlaceRepo)) return null;
  return (
    <a
      className="enlace-repo"
      href={proyecto.enlaceRepo}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Abrir el repo de ${proyecto.nombre}`}
      title="Abrir el repo"
    >
      <svg
        className="enlace-repo__icono"
        viewBox="0 0 16 16"
        width="14"
        height="14"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M9 2h5v5M14 2 7.5 8.5M12 9.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  );
}
